import { api } from "../../../lib/api";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const add = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const monday = (d) => add(d, -((d.getDay() + 6) % 7));

export function presetRange(key) {
  const t = new Date(); t.setHours(12, 0, 0, 0);
  const y = t.getFullYear(), m = t.getMonth();
  switch (key) {
    case "today": return [iso(t), iso(t)];
    case "yesterday": return [iso(add(t, -1)), iso(add(t, -1))];
    case "this_week": return [iso(monday(t)), iso(add(monday(t), 6))];
    case "last_week": return [iso(add(monday(t), -7)), iso(add(monday(t), -1))];
    case "last_month": return [iso(new Date(y, m - 1, 1, 12)), iso(new Date(y, m, 0, 12))];
    case "this_quarter": { const q = Math.floor(m / 3) * 3; return [iso(new Date(y, q, 1, 12)), iso(new Date(y, q + 3, 0, 12))]; }
    default: return [iso(new Date(y, m, 1, 12)), iso(new Date(y, m + 1, 0, 12))];
  }
}

export const PRESETS = [["today", "Today"], ["yesterday", "Yesterday"], ["this_week", "This week"],
  ["last_week", "Last week"], ["this_month", "This month"], ["last_month", "Last month"],
  ["this_quarter", "This quarter"], ["custom", "Custom"]];

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const num = (n) => Number(n || 0).toLocaleString("en-IN");

export function toParams(f, extra = {}) {
  const p = { from_date: f.from, to_date: f.to, source: f.source, ...extra };
  ["category", "sr_status", "pay_state", "pay_source", "q"].forEach(k => { if (f[k]) p[k] = f[k]; });
  return p;
}

export async function downloadCsv(kind, f, group) {
  const r = await api.get(`/finance/invoice-analytics/export/${kind}.csv`,
    { params: toParams(f, { group }), responseType: "blob" });
  saveBlob(r.data, `invoice-analytics_${kind}_${f.from}_to_${f.to}.csv`);
}

export function saveBlob(blob, name) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function rowsToCsv(header, rows) {
  const esc = (v) => { const s = v == null ? "" : String(v); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };
  return new Blob(["\ufeff" + [header, ...rows].map(r => r.map(esc).join(",")).join("\n")], { type: "text/csv" });
}

export function periodLabel(p, group) {
  if (group === "month") return new Date(`${p}-01T12:00:00`).toLocaleDateString("en-IN", { month: "short", year: "numeric" });
  const d = new Date(`${p}T12:00:00`);
  return (group === "week" ? "Wk " : "") + d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
}
